import _find from "lodash/find";
import { h } from "vue";
import { Icon } from "@iconify/vue";

export const languages = [
    {
        key: "en",
        name: "Anglais",
        icon: h(Icon, {
            icon: "circle-flags:us",
        }),
    },
    {
        key: "fr",
        name: "Français",
        icon: h(Icon, {
            icon: "circle-flags:fr",
        }),
    },
    {
        key: "it",
        name: "Italien",
        icon: h(Icon, {
            icon: "circle-flags:it",
        }),
    },
    {
        key: "de",
        name: "Allemand",
        icon: h(Icon, {
            icon: "circle-flags:de",
        }),
    },
    {
        key: "es",
        name: "Espagnol",
        icon: h(Icon, {
            icon: "circle-flags:es",
        }),
    },
    {
        key: "pt",
        name: "Portugais",
        icon: h(Icon, {
            icon: "circle-flags:pt",
        }),
    },
    {
        key: "tr",
        name: "Turc",
        icon: h(Icon, {
            icon: "circle-flags:tr",
        }),
    },
    {
        key: "nl",
        name: "Néerlandais",
        icon: h(Icon, {
            icon: "circle-flags:nl",
        }),
    },
    {
        key: "pl",
        name: "Polonais",
        icon: h(Icon, {
            icon: "circle-flags:pl",
        }),
    },
    {
        key: "ro",
        name: "Roumain",
        icon: h(Icon, {
            icon: "circle-flags:ro",
        }),
    },
    {
        key: "kr",
        name: "Coréen",
        icon: h(Icon, {
            icon: "circle-flags:kr",
        }),
    },
    {
        key: "ru",
        name: "Russe",
        icon: h(Icon, {
            icon: "circle-flags:ru",
        }),
    },
    {
        key: "ja",
        name: "Japonais",
        icon: h(Icon, {
            icon: "circle-flags:ja",
        }),
    },
    {
        key: "zh",
        name: "Mandarin",
        icon: h(Icon, {
            icon: "circle-flags:zh",
        }),
    },
    {
        key: "gr",
        name: "Grec",
        icon: h(Icon, {
            icon: "circle-flags:gr",
        }),
    },
    {
        key: "hi",
        name: "Hindi",
        icon: h(Icon, {
            icon: "circle-flags:hi",
        }),
    },
    {
        key: "id",
        name: "Indonésien",
        icon: h(Icon, {
            icon: "circle-flags:id",
        }),
    },
    {
        key: "vi",
        name: "Vietnamien",
        icon: h(Icon, {
            icon: "circle-flags:vn",
        }),
    },
    {
        key: "th",
        name: "Thaï",
        icon: h(Icon, {
            icon: "circle-flags:th",
        }),
    },
    {
        key: "sv",
        name: "Suédois",
        icon: h(Icon, {
            icon: "circle-flags:se",
        }),
    },
    {
        key: "no",
        name: "Norvégien",
        icon: h(Icon, {
            icon: "circle-flags:no",
        }),
    },
    {
        key: "da",
        name: "Danois",
        icon: h(Icon, {
            icon: "circle-flags:da",
        }),
    },
    {
        key: "hu",
        name: "Hongrois",
        icon: h(Icon, {
            icon: "circle-flags:hu",
        }),
    },
    {
        key: "uk",
        name: "Ukrainien",
        icon: h(Icon, {
            icon: "circle-flags:ua",
        }),
    },
    {
        key: "ie",
        name: "Irlandais",
        icon: h(Icon, {
            icon: "circle-flags:ie",
        }),
    },
    {
        key: "ar",
        name: "Arabe",
        icon: h(Icon, {
            icon: "circle-flags:ae",
        }),
    },
    {
        key: "pk",
        name: "Pakistanais",
        icon: h(Icon, {
            icon: "circle-flags:pk",
        }),
    },
    {
        key: "pt-BR",
        name: "Brésilien",
        icon: h(Icon, {
            icon: "circle-flags:br",
        }),
    },
    {
        key: "zh-TW",
        name: "Taïwanais",
        icon: h(Icon, {
            icon: "circle-flags:tw",
        }),
    },
    {
        key: "fi",
        name: "Finnois",
        icon: h(Icon, {
            icon: "circle-flags:fi",
        }),
    },
    {
        key: "cz",
        name: "Tchèque",
        icon: h(Icon, {
            icon: "circle-flags:cz",
        }),
    },
    {
        key: "sk",
        name: "Slovaque",
        icon: h(Icon, {
            icon: "circle-flags:sk",
        }),
    },
    {
        key: "bg",
        name: "Bulgare",
        icon: h(Icon, {
            icon: "circle-flags:bg",
        }),
    },
    {
        key: "rs",
        name: "Serbe",
        icon: h(Icon, {
            icon: "circle-flags:rs",
        }),
    },
    {
        key: "hr",
        name: "Croate",
        icon: h(Icon, {
            icon: "circle-flags:hr",
        }),
    },
    {
        key: "si",
        name: "Slovène",
        icon: h(Icon, {
            icon: "circle-flags:si",
        }),
    },
    {
        key: "mk",
        name: "Macédonien",
        icon: h(Icon, {
            icon: "circle-flags:mk",
        }),
    },
    {
        key: "al",
        name: "Albanais",
        icon: h(Icon, {
            icon: "circle-flags:al",
        }),
    },
    {
        key: "ge",
        name: "Géorgien",
        icon: h(Icon, {
            icon: "circle-flags:ge",
        }),
    },
    {
        key: "lv",
        name: "Letton",
        icon: h(Icon, {
            icon: "circle-flags:lv",
        }),
    },
    {
        key: "lt",
        name: "Lituanien",
        icon: h(Icon, {
            icon: "circle-flags:lt",
        }),
    },
    {
        key: "ee",
        name: "Estonien",
        icon: h(Icon, {
            icon: "circle-flags:ee",
        }),
    },
    {
        key: "he",
        name: "Hébreu",
        icon: h(Icon, {
            icon: "circle-flags:he",
        }),
    },
];

export const getLanguage = (language) => {
    return _find(languages, ["key", language]);
};
